import { faCheck, faXmark } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Typography from '@sharedComponents/Typography';
import cx from 'classnames';

import * as style from './style.module.css';

export const List = ({ title = '', customStyle = null, children }) => {
    return (
        <div>
            {title && <Typography>{title}</Typography>}
            <ul className={customStyle ? style[customStyle] : null}>{children}</ul>
        </div>
    );
};

export const ListItem = ({ status, customStyle = null, children }) => {
    return (
        <div className={cx(style.defaultListItem, customStyle ? style[customStyle] : null)}>
            {children}
            {status === 'neutral' && <FontAwesomeIcon icon={faCheck} className={style.iconNeutralColor} />}
            {status === 'success' && <FontAwesomeIcon icon={faCheck} className={style.iconSuccessColor} />}
            {status === 'fail' && <FontAwesomeIcon icon={faXmark} className={style.iconFailColor} />}
        </div>
    );
};
